/** Barra de vida do Boss (topo-centro): nome + HP + fase. Placas de armadura p/ o Colossus. */
import { i18n } from "../i18n/i18n";
import { fmtNum } from "../utils/format";
import type { Boss } from "./Boss";

export class BossHUD {
  private readonly root: HTMLDivElement;
  private readonly nameEl: HTMLElement;
  private readonly phaseEl: HTMLElement;
  private readonly fill: HTMLElement;
  private readonly ghost: HTMLElement; // 10.9GT
  private lastFrac = 1;
  private readonly hpLabel: HTMLElement;
  private readonly plates: HTMLElement;

  constructor(uiRoot: HTMLElement) {
    this.root = document.createElement("div");
    this.root.className = "boss-hud";
    this.root.hidden = true;
    this.root.innerHTML = `
      <div class="boss-name"></div>
      <div class="boss-plates"></div>
      <div class="bar boss"><div class="ghost"></div><div class="fill"></div><div class="label boss-hp-label"></div></div>
      <div class="boss-phase"></div>`;
    uiRoot.appendChild(this.root);
    this.nameEl = this.root.querySelector(".boss-name")!;
    this.phaseEl = this.root.querySelector(".boss-phase")!;
    this.fill = this.root.querySelector(".boss .fill")!;
    this.ghost = this.root.querySelector(".boss .ghost")!;
    this.hpLabel = this.root.querySelector(".boss-hp-label")!;
    this.plates = this.root.querySelector(".boss-plates")!;
  }

  show(): void {
    this.root.hidden = false;
    document.body.classList.add("boss-on"); // 10.9EO — a pilha do canto desce pra baixo da barra
  }
  hide(): void {
    this.root.hidden = true;
    document.body.classList.remove("boss-on");
  }

  update(boss: Boss): void {
    this.nameEl.textContent = i18n.t(boss.nameKey);
    this.fill.style.transform = `scaleX(${boss.hpFraction})`;
    this.ghost.style.transition = boss.hpFraction >= this.lastFrac ? "none" : ""; // 10.9GT
    this.ghost.style.transform = `scaleX(${boss.hpFraction})`;
    this.lastFrac = boss.hpFraction;
    this.hpLabel.textContent = `${fmtNum(Math.ceil(boss.health.current))}/${fmtNum(boss.health.max)}`;
    this.root.classList.toggle("rage", boss.phaseNumber >= 2);

    // Crystal Plates (Colossus): ◆ viva · ◇ quebrada
    const info = boss.plateInfo?.();
    if (info) {
      let s = "";
      for (let i = 0; i < info.total; i++) s += i < info.alive ? "◆" : "◇";
      this.plates.textContent = s;
      this.plates.hidden = false;
      this.plates.classList.toggle("broken", info.alive === 0);
      this.phaseEl.textContent = info.coreExposed ? i18n.t("boss.coreExposed") : "";
    } else {
      this.plates.hidden = true;
      this.phaseEl.textContent = boss.phaseNumber >= 3 ? i18n.t("boss.phaseRage") : "";
    }
  }
}
